module.exports = __webpack_public_path__ + "assets/img/smsimg5.a3313ce1.png";